import { render, staticRenderFns } from "./ModalNew.vue?vue&type=template&id=1bd12354&v-slot%3Aactivator=%7B%20on%20%7D"
import script from "./ModalNew.vue?vue&type=script&lang=js"
export * from "./ModalNew.vue?vue&type=script&lang=js"
import style0 from "./ModalNew.vue?vue&type=style&index=0&id=1bd12354&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports